import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CatalogDiamondDataService from "../../../services/catalog-diamond.service";
import { Spin, Tooltip, Alert } from "antd";

const ColorStoneFtpCredentials = (props) => {
  const { t } = useTranslation();
  const [ftpData, setFtpData] = useState({
    locationData: "",
    userName: "",
    password: "",
    id: "",
    importMethod: "",
  });

  const { locationData, userName, password, importMethod } = ftpData;
  const loginDetials = useSelector((state) => state.loginReducer);
  const [loading, setloading] = useState(false);
  const [ftpNotSetup, setFtpNotSetup] = useState(false);

  // Helper to get type label
  const typeLabel =  t("Color Stone");

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          handleMangeFtpDetails(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
    // eslint-disable-next-line
  }, [props]);

  const handleMangeFtpDetails = (Id) => {
    try {
      let inputData = {
        dealerID: Id,
        type: "ColorStone"  ,
      };
      setloading(true);
      CatalogDiamondDataService.MangeFtpDetails(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData && responseData.length > 0) {
              setloading(false);
              setFtpNotSetup(false);
              const parts = responseData[0].location.split("\\");
              const secondLast = parts.length > 1 ? parts[parts.length - 2] : "";
              setFtpData({
                locationData: secondLast,
                userName: responseData[0].userName,
                password: responseData[0].password,
                id: responseData[0].id,
                importMethod:
                  responseData[0].addUpdate === "False"
                    ? "Replace All"
                    : "Add & Update",
              });
            } else {
              setFtpData({
                locationData: "",
                userName: "",
                password: "",
                id: "",
              });
              setFtpNotSetup(true);
              setloading(false);
            }
          } else {
            setFtpData({
              locationData: "",
              userName: "",
              password: "",
              id: "",
            });
            setFtpNotSetup(true);
            setloading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setFtpNotSetup(true);
          setloading(false);
        });
    } catch (error) {
      console.log(error);
      setFtpNotSetup(true);
      setloading(false);
    }
  };

  /* Custom Binding Ends */
  return (
    <div className="prodetail__section">
      <div className="form__fields">
        <div className="col-md-12">
          <div className="prod__maindiv data__maping diamond__mapping">
            <Spin spinning={loading} size="large">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="workarea__heading mt-0 mb-3">
                    {" "}
                    {t("Manage FTP Credential")}{" "}
                  </h4>
                </div>
                {ftpNotSetup && (
                  <div className="col-md-12 mb-3">
                    <Alert
                      message={t(
                        `FTP for ${typeLabel} has not been set up yet.`
                      )}
                      type="warning"
                      showIcon
                    />
                  </div>
                )}
                <div className="col-md-6">
                  <div className="input__block">
                    <label>{t("FTP Host Name - Location")}</label>
                    <input
                      type="text"
                      placeholder={t("Enter FTP Location")}
                      name="locationData"
                      value={"ftp.gemfind.net - " + locationData}
                      disabled={ftpNotSetup}
                    />
                  </div>

                  <div className="input__block">
                    <label>{t("FTP User Name")}</label>
                    <input
                      type="text"
                      placeholder={t("Enter FTP User Name")}
                      name="userName"
                      value={userName}
                      disabled={ftpNotSetup}
                    />
                  </div>

                  <div className="input__block">
                    <label>{t("FTP User Password")}</label>
                    <input
                      type="text"
                      placeholder={t("Enter FTP User Password")}
                      name="password"
                      autoComplete="new-password"
                      value={password}
                      disabled={ftpNotSetup}
                    />
                  </div>
                  <div key={ftpData} className="input__block">
                    <label>{t("Import Method")}</label>
                    <input
                      type="text"
                      placeholder={t("Enter Import Type")}
                      name="importMethod"
                      value={importMethod}
                      disabled={ftpNotSetup}
                    />
                  </div>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorStoneFtpCredentials;
